import React from 'react'
import styled from 'styled-components'

export const DropdownCopytradingTopTradersLoader = () => {
  return (
    <StyledDropdownCopytradingTopTradersLoader>
      <LoaderSpin />
    </StyledDropdownCopytradingTopTradersLoader>
  )
}

const StyledDropdownCopytradingTopTradersLoader = styled.div`
  background: linear-gradient(90deg, #103276 0%, #1773df 92.19%);
  box-shadow: 0px 4px 8px rgba(24, 98, 196, 0.2);
  border-radius: 8px;
  flex-grow: 1;
  display: flex;
  align-items: center;
  justify-content: center;
`

const LoaderSpin = styled.div`
  border-width: 3px 3px 3px;
  border-style: solid;
  border-color: #ffffff transparent transparent;
  border-image: initial;
  opacity: 0.8;
  border-radius: 50%;
  width: 42px;
  height: 42px;
  animation: spin 1s linear infinite;

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`
